import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Label, Row, Collapse, Input, Table, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
// import Chart from 'react-apexcharts'
import './StyleResult.css'
import { ConfigServer } from "../../data/config";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TabMenu } from 'primereact/tabmenu';
import { useMicrositeClient } from '../../hooks/micrositeClient/useMicrositeClient';
import { DialogChartMicrositePatients } from './DialogChartMicrositePatients';
import Select from 'react-select';
import {demoLis, demo, semlab, insan, cedimi} from '../../constant/globalConstantsTypeClients'

export const ResultsFromNimPublic = () => {
    const {

        viewData, workOrderPrintResultCaptureView, reload, items, activeIndex, setActiveIndex,

        downloadSheetResults, profilesHistories, headerStyle, cellStyle, validateData, input_nim,

        showPassword, input_password, handleInputChange, toggleShowPassword, loadingForm, loading,
        loadingNim,

        profiles, toggleCollapse, openProfiles, idd, listaExamenes, toggleExamCollapse, openExams,
        
        selectedData, handleSelectChange, combinedOptions,
        
        //#region chart
        chartDialogVisible, setChartDialogVisible, chartData, chartOptions, 
        loadChartData, currentAnalyteId, setCurrentAnalyteId, currentPatientNim, setCurrentPatientNim,

        handleSelectChangeExamProfile, optionsForSelect, selectedOption, urlHelenLis


        // #endregion




    } = useMicrositeClient();

    return (
        <div className="b-center bg-size"  >
            <Container className="" fluid={true} style={{ backgroundColor: "#F8F9FA", boxSizing: "border-box" }}>
                {
                    viewData ?
                        <>
                            <div className='divHeader p-0'>
                                <Col xs="12">
                                    <Row className="align-items-center">
                                        <Col xs="12" lg="3" className="text-center text-lg-left mb-2 mb-lg-0">
                                        <img
                                                src={require("../../assets/images/loginHelenLabs/TomaDeMuestra/LogoHelenLabs.svg")}
                                                alt="Helen Logo"
                                                className="img-fluid"
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "250px"
                                                }}
                                            />
                                        
                                            
                                        </Col>

                                        <Col xs="12" lg="6" className="text-center mb-2 mb-lg-0">
                                            <label className='TitleCaptureResults' style={{ fontSize: '1.2rem' }}>
                                                Consulta de resultados
                                            </label>
                                        </Col>

                                        <Col xs="12" lg="3" className="text-center text-lg-right">
                                        {
                                            urlHelenLis !== insan && <img
                                                src={ConfigServer.serverUrl + "/api/Configuration/Logo"}
                                                alt="Logo derecho"
                                                className="img-fluid"
                                                style={{
                                                    width: "100%",
                                                    maxWidth: "200px"
                                                }}  
                                            />
                                        }
                                          
                                        
                                           
                                        </Col>
                                    </Row>
                                </Col>
                            </div>
                        

                            <Col xs="12" sm="12" md="12" lg="12" xl="12"> <br />
                                <Row className="g-4">
                                    {/* CARD IZQUIERDA */}
                                    <Col xs="12" md="12">
                                        <Card className="shadow-sm border height-equal pricingtable rounded-3 p-3 mb-4">
                                            
                                            {/* <Button
                                                color="light"
                                                size="sm"
                                                className="position-absolute top-0 end-0 m-2 p-1"
                                                onClick={reload}
                                                title="Cerrar sesión"
                                                style={{ lineHeight: 1 }}
                                            >
                                                <i className="fa fa-sign-out text-primary" style={{ fontSize: "1rem" }}></i>
                                            </Button> */}

                                            <Row>

                                            <Col sm="4" className="text-center">
                                                <img
                                                    src={
                                                        workOrderPrintResultCaptureView.gender === "Femenino"
                                                        ? require("../../assets/images/user/mujer.png")
                                                        : require("../../assets/images/user/hombre.png")
                                                    }
                                                    alt="Paciente"
                                                    className="img-fluid rounded-circle border shadow-sm mb-3"
                                                    style={{
                                                        width: "100px",
                                                        height: "100px",
                                                        objectFit: "cover",
                                                        borderColor: "#17a6c6",
                                                        borderWidth: "2px"
                                                    }}

                                                    
                                                />
                                                    <h4 className="fw-bold text-dark mb-2" style={{ fontSize: "1.15rem" }}>
                                                        {workOrderPrintResultCaptureView.name_patient}
                                                    </h4>
                                                <div className="mb-4">
                                                    <strong>NIM:</strong> {workOrderPrintResultCaptureView.nim}
                                                </div>

                                                {loading ? (
                                                <p className="fw-semibold" style={{ fontSize: "0.9rem", color: "#dc3545" }}>
                                                    Descargando, por favor espera... <i className="fa fa-spinner fa-spin ms-2" />
                                                </p>
                                                ) : workOrderPrintResultCaptureView.status ? (
                                                    <>
                                                    <div style={{ 
                                                        display: "flex", 
                                                        flexDirection: "column", 
                                                        alignItems: "center", 
                                                        justifyContent: "center", 
                                                        gap: "8px",
                                                        marginTop: "20px"
                                                    }}>
                                                        <Button
                                                            onClick={downloadSheetResults}
                                                            size="sm"
                                                            className="btn-red px-4 py-2"
                                                            style={{ fontWeight: "600", fontSize: "0.9rem" }}
                                                        >
                                                            Descargar Resultados
                                                        </Button>

                                                        <Button
                                                            size="sm"
                                                            onClick={reload}
                                                            className="btn-blue px-4 py-2"
                                                            style={{ fontWeight: "600", fontSize: "0.9rem" }}

                                                        >
                                                            <i className="fa fa-sign-out  me-2 mr-1" style={{ fontSize: "13px" }}></i>
                                                            Cerrar Sesión
                                                        </Button>
                                                    </div>

                                                    </>

                                                ) : (
                                               <>
                                                   <div className="d-flex flex-column gap-2 align-items-center">

                                                        <button
                                                            size="sm"
                                                            disabled
                                                            className="btn-gray px-4 py-2"
                                                            style={{ fontWeight: "600", fontSize: "0.9rem" }}
                                                        >
                                                            Sin resultados
                                                        </button>
                                                        <br />
                                                        <Button
                                                            size="sm"
                                                            onClick={reload}
                                                            className="btn-blue px-4 py-2"
                                                            style={{ fontWeight: "600", fontSize: "0.9rem" }}
                                                        >
                                                            <i className="fa fa-sign-out me-2" style={{ fontSize: "13px" }}></i>
                                                            Cerrar Sesión
                                                        </Button>

                                                    </div>


                                                </>
                                                )}
                                            </Col>

                                            <Col sm="8">
                                                <TabMenu
                                                model={items}
                                                activeIndex={activeIndex}
                                                onTabChange={(e) => setActiveIndex(e.index)}
                                                style={{ width: "100%" }}
                                                />
                                                <br />

                                            {activeIndex === 0 && (
                                                <div>
                                        
                                                <div
                                                    style={{
                                                    display: "grid",
                                                    gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
                                                    gap: "0.7rem",
                                                    }}
                                                >
                                                    {[
                                                    { label: "Género", value: workOrderPrintResultCaptureView.gender },
                                                    { label: "Fecha de Nacimiento", value: workOrderPrintResultCaptureView.birthday },
                                                    { label: "Edad", value: workOrderPrintResultCaptureView.age },
                                                    { label: "Teléfono", value: workOrderPrintResultCaptureView.phone },
                                                    { label: "Fecha de Admisión", value: workOrderPrintResultCaptureView.date_creation },
                                                    { label: "Consulta Resultados", value: workOrderPrintResultCaptureView.date_release },
                                                    ].map((item, idx) => (
                                                        <div
                                                            key={idx}
                                                            style={{
                                                            background: "linear-gradient(145deg, #e3f2fd, #ffffff)",
                                                            padding: "0.6rem 0.8rem",
                                                            borderRadius: "14px",
                                                            boxShadow: "5px 5px 10px rgba(0,0,0,0.05), -5px -5px 10px rgba(255,255,255,0.7)",
                                                            transition: "all 0.3s ease",
                                                            cursor: "default",
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            textAlign: "center",
                                                            }}
                                                        >
                                                            <div style={{ fontSize: "11px", fontWeight: 500, color: "#3a3a3a", marginBottom: "0.15rem" }}>
                                                            {item.label}
                                                            </div>
                                                            <div style={{ fontSize: "11px", fontWeight: 600, color: "#0d3b66" }}>
                                                            {item.value ?? <span style={{ fontStyle: "italic", color: "#7a7a7a" }}>Sin dato</span>}
                                                            </div>
                                                        </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            )}
                                                
                                                {activeIndex === 1 && (
                                                    <>
                                                
                                                    <DataTable
                                                        value={profilesHistories}
                                                        paginator
                                                        rows={5}
                                                        responsiveLayout="scroll"
                                                        emptyMessage="No hay resultados disponibles."
                                                        className="data-table p-datatable-striped p-datatable-sm"
                                                    >
                                                        <Column header="#" body={(rowData, options) => options.rowIndex + 1} headerStyle={headerStyle} style={cellStyle} />
                                                        <Column field="nim" header="Nim" headerStyle={headerStyle} style={cellStyle} />
                                                        <Column field="date" header="Fecha y Hora de Registro" headerStyle={headerStyle} style={cellStyle} />
                                                        <Column
                                                        header="PDF"

                                                       body={(rowData) => {

                                                        // const sinExamenes = !rowData?.lista_examenes || rowData?.lista_examenes.length === 0;
                                                        // const listaVacia = !rowData?.lista || Object.keys(rowData?.lista).length === 0;


                                                        // if (sinExamenes && listaVacia) {
                                                        //     return null; 
                                                        // }

                                                        return (
                                                            <button
                                                                type="button"
                                                                className="btn-red btn-sm"
                                                                onClick={(e) => downloadSheetResults(e, rowData.nim)}
                                                                disabled={loadingNim === rowData.nim}
                                                            >
                                                                {loadingNim === rowData.nim ? (
                                                                    <>Cargando... <i className="fa fa-spinner fa-spin"></i></>
                                                                ) : (
                                                                    <>PDF <i className="icofont icofont-download-alt"></i></>
                                                                )}
                                                            </button>
                                                        );
                                                    }}
                                                        headerStyle={headerStyle} style={cellStyle}
                                                        />
                                                    </DataTable>
                                                    </>
                                                )}
                                            </Col>
                                            </Row>
                                        </Card>
                                    </Col>


                                    {(urlHelenLis === semlab || urlHelenLis === demoLis || urlHelenLis === cedimi  || urlHelenLis === demo) && (
                                        <Col xs="12" sm="12" md="12" lg="12" xl="12" className='p-l-0 p-r-0' >
                                                <Card  className="shadow-sm border height-equal pricingtable rounded-3 p-3 mb-4">
                                                    <div style={{ 
                                                            backgroundColor: '#105e8f', 
                                                            color: '#fff', 
                                                            padding: '5px 10px', 
                                                            borderRadius: '8px', 
                                                            marginBottom: '10px', 
                                                            fontWeight: 'bold', 
                                                            textAlign: 'center',
                                                            boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                                        }}>
                                                        Mis Resultados
                                                        </div>
                                                        Seleccione un examen o perfil 
                                                        <Select
                                                            classNamePrefix="select"
                                                            name="id_exam_include"
                                                            options={optionsForSelect}
                                                            value={selectedOption}
                                                            placeholder="Seleccione una opción"
                                                            isClearable={false}
                                                            onChange={handleSelectChangeExamProfile}
                                                            menuPortalTarget={document.body} 
                                                            styles={{
                                                                menuPortal: (base) => ({ ...base, zIndex: 9999 })
                                                            }}
                                                        />

                                                    
                                                        <br />
                                                    {selectedData.length > 0 ? (
                                                        <DataTable
                                                                value={selectedData}
                                                                paginator
                                                                rows={10}
                                                                responsiveLayout="scroll"
                                                                emptyMessage="No hay resultados disponibles."
                                                                className="p-datatable-sm p-datatable-striped p-datatable-gridlines"
                                                            >
                                                                <Column 
                                                                    header="#" 
                                                                    body={(rowData, options) => options.rowIndex + 1} 
                                                                    headerStyle={headerStyle} style={cellStyle}
                                                                />
                                                        <Column
                                                                header="Prueba"
                                                                body={(rowData) => {
                                                                    const isNumeric = !isNaN(Number(rowData.result)); 
                                                                    return (
                                                                        <span
                                                                            style={{
                                                                                color: isNumeric ? "#0079C7" : "#333",
                                                                                cursor: isNumeric ? "pointer" : "default",
                                                                                textDecoration: isNumeric ? "underline" : "none"
                                                                            }}
                                                                            onClick={() => {
                                                                                if (isNumeric) {
                                                                                    loadChartData(rowData.nim, rowData.id_analyte);
                                                                                    setCurrentAnalyteId(rowData.id_analyte);
                                                                                    setCurrentPatientNim(rowData.nim);
                                                                                }
                                                                            }}
                                                                        >
                                                                            {rowData.name}
                                                                        </span>
                                                                    );
                                                                }}
                                                                style={{ fontSize: '11px', textAlign: 'center' }}
                                                                headerStyle={headerStyle}
                                                            />


                                                                <Column 
                                                                    field="result" 
                                                                    header="Resultado" 
                                                                    headerStyle={headerStyle} style={cellStyle}
                                                                />

                                                                <Column 
                                                                    field="unit" 
                                                                    header="Unidad" 
                                                                    headerStyle={headerStyle} style={cellStyle}
                                                                />
                                                                <Column 
                                                                    field="range" 
                                                                    header="Intervalo Biológico de Referencia" 
                                                                    headerStyle={headerStyle} 
                                                                    style={cellStyle}
                                                                    body={(rowData) => {
                                                                        const displayValue = rowData.range || (rowData.text_alerts && rowData.text_alerts[0]) || '-';
                                                                        return <span>{displayValue}</span>;
                                                                    }}
                                                                />

                                                            </DataTable>

                                                    
                                                    ) : (
                                                    <p className="text-center mt-2" style={{ fontWeight: 'bold', color: '#0079C7' }}>
                                                        Selecciona un perfil o examen para ver los resultados.
                                                    </p>

                                                    )}
                                                </Card>
                                        
                                        
                                        </Col>
                                    )}
                                  
                                </Row>
                            </Col>
                        </>
                        :
                        <>

                            {/* <Col sm="12" className="p-0" style={{ position: "relative", overflow: "hidden" }}> */}
                                <div
                    style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backdropFilter: "blur(40px)",
                        WebkitBackdropFilter: "blur(40px)",
                        background: `
                        linear-gradient(
                            to bottom,
                            rgba(161, 201, 221, 0.95) 0%,
                            rgba(133, 202, 236, 0.75) 35%,
                            rgba(87, 212, 250, 0.65) 65%,
                            rgba(17, 125, 212, 0.9) 100%
                        )
                        `,
                    }}
                />

                                <Row
                                    className="justify-content-center align-items-center"
                                    style={{ minHeight: "100vh", margin: 0, zIndex: 2, position: "relative" }}>
                                    <Col xs="12" md="10" lg="8">
                                        <div
                                            className="d-flex flex-column flex-md-row align-items-center justify-content-between"
                                            style={{
                                                background: "rgba(243, 243, 243, 0.63)",
                                                backdropFilter: "blur(18px) saturate(160%)",
                                                WebkitBackdropFilter: "blur(18px) saturate(160%)",
                                                borderRadius: "24px",
                                                boxShadow: `
                                                    0 20px 40px rgba(0, 0, 0, 0.13),
                                                    inset 0 1px 0 rgba(255, 255, 255, 0.4)
                                                `,
                                                padding: "2rem",
                                                border: "1px solid rgba(255, 255, 255, 0.25)",
                                                }}
                                            >
                                            <div
                                                style={{
                                                    flex: 2,
                                                    height: "100%",
                                                    overflow: "hidden",
                                                    borderRadius: "15px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <img
                                                    src={require("../../assets/images/microsite/login-client.jpg")}
                                                    alt="imagen"
                                                    style={{
                                                        width: "100%",
                                                        height: "100%",
                                                        objectFit: "cover",
                                                        borderRadius: "15px",
                                                        marginRight: "auto"
                                                    }}
                                                />
                                            </div>


                                            <div
                                                style={{
                                                    flex: 1,
                                                    padding: "0 2rem",
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    justifyContent: "center",
                                                    height: "100%",
                                                }}
                                            >


                                                <div className="text-center mb-3">
                                                    {
                                                         urlHelenLis !== insan &&   <img
                                                        className="b-r-10"
                                                        src={ConfigServer.serverUrl + "/api/Configuration/Logo"}
                                                        style={{ width: "75%", textAlign: "center" }}
                                                        alt=""
                                                    />
                                                    }
                                                  
                                                </div>

                                                <div className="text-center mb-2">
                                                    <p className="title m-b-0" style={{ fontWeight: "lighter" }}>
                                                        <img
                                                            src={require("../../assets/images/loginHelenLabs/HelenLabs.png")}
                                                            alt="helenLogo"
                                                            style={{ width: "6%" }}
                                                        />
                                                        &nbsp;&nbsp;&nbsp;
                                                        <label className="LabelLogin p-1 p-t-0" style={{ fontSize: "15px" }}>
                                                            HELEN
                                                        </label>
                                                        <label className="LabelLogin2 p-1 p-t-0" style={{ fontSize: "15px" }}>
                                                            LABS
                                                        </label>
                                                    </p>
                                                </div>

                                                <div className="text-center mb-3">
                                                    <h6>Accede a tus resultados</h6>
                                                </div>

                                                {/* login form */}
                                                <Form className="theme-form text-center" method="get" onSubmit={validateData}>
                                                    <div className="mx-auto" style={{ maxWidth: "100%" }}>
                                                        <FormGroup>
                                                            <Label className="labelMenu">Ingresa tu NIM</Label>
                                                            <Input
                                                                className="form-control-sm input-air-primary btn-pill"
                                                                type="text"
                                                                value={input_nim}
                                                                name="input_nim"
                                                                onChange={handleInputChange}
                                                                style={{ border: "#0079C7 2px solid" }}
                                                            />
                                                        </FormGroup>

                                                        <FormGroup>
                                                            <Label className="labelMenu">Ingresa tu contraseña</Label>
                                                            <InputGroup>
                                                                <Input
                                                                    type={showPassword ? "text" : "password"}
                                                                    className="form-control-sm input-air-primary btn-pill"
                                                                    style={{ border: "#0079C7 2px solid" }}
                                                                    name="input_password"
                                                                    value={input_password}
                                                                    onChange={handleInputChange}
                                                                    placeholder="Contraseña"
                                                                    autoComplete="new-password"
                                                                />
                                                                <InputGroupAddon addonType="append">
                                                                    <InputGroupText>
                                                                        <span
                                                                            className={`fa fa-eye${showPassword ? "-slash" : ""}`}
                                                                            onClick={toggleShowPassword}
                                                                            style={{ cursor: "pointer" }}
                                                                        />
                                                                    </InputGroupText>
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                        </FormGroup>

                                                        <div className="text-center">
                                                          <Button
                                                                type="submit"
                                                                color="primary"
                                                                disabled={loadingForm}
                                                                className="btn-pill"
                                                                >
                                                                {loadingForm && <i className="pi pi-spin pi-spinner mr-2"></i>}
                                                                {loadingForm ? "Cargando..." : "Validar datos"}
                                                            </Button>

  
                                                        </div>

                                                    </div>
                                                </Form>
                                            </div>
                                        </div>
                                        {/* </div> */}
                                    </Col>
                                </Row>
                            {/* </Col> */}

                        </>
                }

                <DialogChartMicrositePatients
                    {...{
                        chartDialogVisible, setChartDialogVisible, chartOptions, chartData, loadChartData, selectedData,         currentAnalyteId, setCurrentAnalyteId, currentPatientNim, setCurrentPatientNim

                    }}
                />
            </Container >
        </div >
    )
}

